import type { PollService } from "@busbud/core-types";

import type { LegIndex } from "@app/constants/trip";
import { OUTBOUND_LEG_INDEX } from "@app/constants/trip";

import { getSegmentById } from "./get-segment-by-id";
import { getSegmentIdsPerLeg } from "./get-segment-ids-per-leg";
import { throwsIfAccessingReturnLegOfOnewayTrip } from "./leg-access-guard";

export const getLegSegments = (
  trip: PollService.API.PublicTrip | PollService.API.PublicTripV4,
  leg_index: LegIndex
): (PollService.API.PublicSegment | PollService.API.PublicSegmentV4)[] => {
  throwsIfAccessingReturnLegOfOnewayTrip(trip, leg_index);

  const [outbound_segment_ids, return_segment_ids] = getSegmentIdsPerLeg(
    trip.trip_legs
  );
  const segment_ids =
    leg_index === OUTBOUND_LEG_INDEX
      ? outbound_segment_ids
      : return_segment_ids;

  // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  return segment_ids.map(segment_id =>
    getSegmentById(segment_id, trip.segments)
  );
};
